import { createLink } from "@tanstack/react-router"
import type { ComponentProps } from "react"
import IconButton from "@/ui/composed/IconButton"

const IconButtonLink = createLink(
  (props: ComponentProps<typeof IconButton>) => (
    <IconButton {...props} nativeButton={false} role="link" render={<a />} />
  ),
)

export default IconButtonLink
